<script lang="ts">
	import type { HelpPalletsProps } from "./HelpPalletsProps.js";
	import HelpPage from "../components/HelpPage.svelte";
	import { nbspify } from "../../../core/utils/nbspify.js";
	import { setContext } from "svelte";
	import pallets from "../assets/images/pallets.png";
	import { thumbnailImageContextKey } from "../contexts/thumbnailImageContextKey.js";

	type $$Props = HelpPalletsProps;

	const { references, products, categories, blogPosts } = $$restProps as $$Props;

	setContext(thumbnailImageContextKey, pallets);
</script>

<HelpPage
	heading="Chci skladovat palety"
	perex="Naše řešení zahrnují mobilní regály, systémy s dvojitou hloubkou založení, klasické paletové regály, regály s úzkými uličkami, spádové systémy a plně automatizovaná řešení. Prohlédněte si také širokou nabídku příslušenství, které zajistí maximální funkčnost a flexibilitu vašeho skladu. BITO vám poskytne skladovací systém, který zefektivní vaše procesy a podpoří růst vaší firmy."
	{references}
	{products}
	{categories}
	{blogPosts}
>
	<p slot="subHeading">
		{nbspify("Pokud potřebujete")}
		<span class="text-primary">{nbspify("efektivní a bezpečné skladování palet,")}</span>
		{nbspify("nabízíme vám široký výběr regálových systémů přizpůsobených vašim specifickým potřebám.")}
	</p>
</HelpPage>
